/**
 * Kenra Navigation Dropdown
 *
 * Initializes all `.kenra-nav-dropdown` elements on the page with:
 * - Click toggle
 * - Click-outside close
 * - Escape key close
 * - Hover open/close (desktop)
 * - Keyboard support (Enter, Space, ArrowDown)
 * - Theme editor support (re-init on section reload, auto-open in design mode)
 *
 * Registers a single set of global listeners (click-outside, Escape)
 * instead of one per dropdown.
 */
(function () {
  var instances = [];
  var globalListenersAttached = false;

  function initDropdowns(scope) {
    var root = scope || document;
    var dropdowns = root.querySelectorAll('.kenra-nav-dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(function (container) {
      // Skip if already initialized
      if (container.dataset.dropdownInit) return;
      container.dataset.dropdownInit = 'true';

      var trigger = container.querySelector('.kenra-nav-dropdown__trigger');
      var menu = container.querySelector('.kenra-nav-dropdown__menu');
      if (!trigger || !menu) return;

      var isOpen = false;

      function open() {
        isOpen = true;
        menu.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        container.classList.add('is-open');
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        menu.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
        container.classList.remove('is-open');
      }

      function toggle() {
        isOpen ? close() : open();
      }

      // Click trigger to toggle
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });

      // Hover open/close
      container.addEventListener('mouseenter', function () {
        open();
      });
      container.addEventListener('mouseleave', function () {
        // Don't auto-close in theme editor
        if (Shopify.designMode) return;
        close();
      });

      // Keyboard on trigger
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!isOpen) open();
        }
      });

      instances.push({ container: container, close: close, open: open });

      // Auto-open in theme editor if this dropdown has a featured product
      if (Shopify.designMode && container.querySelector('.kenra-nav-dropdown__featured')) {
        open();
      }
    });

    // Attach global listeners once
    if (!globalListenersAttached) {
      globalListenersAttached = true;

      document.addEventListener('click', function (e) {
        instances.forEach(function (inst) {
          if (!inst.container.contains(e.target)) {
            inst.close();
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          instances.forEach(function (inst) {
            inst.close();
          });
        }
      });
    }
  }

  // Initial init
  initDropdowns();

  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    initDropdowns(e.target);
  });

  // Auto-open dropdown with featured product when section is selected in editor
  document.addEventListener('shopify:section:select', function (e) {
    var section = e.target;
    var featured = section.querySelector('.kenra-nav-dropdown__featured');
    if (featured) {
      var dropdown = featured.closest('.kenra-nav-dropdown');
      if (dropdown) {
        var inst = instances.find(function (i) { return i.container === dropdown; });
        if (inst) inst.open();
      }
    }
  });
})();
